import React from 'react';
import { Card } from 'antd';
import CodeBlock from './CodeBlock';

const ViewFileContent = ({ onCopy }) => {
  const fileCommands = [
    {
      code: 'cd /etc && cat DEVICEID',
      description: 'Device ID:',
      subDescription: 'View the device identifier.\nShows unique device ID.',
    },
    {
      code: 'cd /etc/rapid && cat rapid',
      description: 'Rapid Configuration:',
      subDescription: 'View rapid service configuration.\nShows current settings and parameters.',
    },
    {
      code: 'cd /etc/rapid && cat servicemonitor',
      subDescription: 'View servicemonitor configuration.\nShows monitoring settings and parameters.',
    },
  ];

  return (
    <Card title="View File Content" bordered={false}>
      {fileCommands.map((command, index) => (
        <CodeBlock
          key={index}
          code={command.code}
          description={command.description}
          subDescription={command.subDescription}
          onCopy={onCopy}
        />
      ))}
    </Card>
  );
};

export default ViewFileContent; 